import TempInspectionFrom from './TempInspectionFrom';

export default TempInspectionFrom;
